import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { waitForUserLoaded } from '@shs-digi-care-monorepo/frontend-lib/auth';
import { EmeaFeatureService } from '../services/emea-feature.service';
import { EmeaFeature } from '../services/emea-feature.model';

/**
 * Creates a route guard that grants access only when the given EMEA feature is
 * enabled for the current user. Awaits the initial user load before evaluating
 * the feature, then redirects to the app root.
 */
export const canActivateFeature =
    (feature: EmeaFeature, redirectTo = '/'): CanActivateFn =>
    async (): Promise<boolean | UrlTree> => {
        const store = inject(Store);
        const router = inject(Router);
        const features = inject(EmeaFeatureService);

        await waitForUserLoaded(store);

        return features.isActive(feature) ? true : router.parseUrl(redirectTo);
    };
